import actionTypes from '../actionsFactory/types';
import { gwPost, gwGet } from '../actionsFactory/gwRequest';
import createBaseActions, { setPostBody } from '../actionsFactory';
import API_PATH from '../actionsFactory/apiPath';

const { SET_VOTE_PROJECT, SET_VOTE_LOG } = actionTypes;

export const setVoteProject = createBaseActions(SET_VOTE_PROJECT, 'data');
export const setVoteLogs = createBaseActions(SET_VOTE_LOG, 'data');

export const fetVoteProject = (isLogin) => async (dispatch) => {
  try {
    const { success, data } = isLogin ? await gwPost(
      API_PATH.VOTE2_PROJECT2, { ...setPostBody({ }) }
    ) : await gwGet(API_PATH.VOTE2_PROJECT);
    if (success) dispatch(setVoteProject({ voteProject: data, isLogin }));
  } catch (error) {
    throw error;
  }
};

export const fetchVoteLogs = () => async (dispatch) => {
  try {
    const { success, data } = await gwPost(
      API_PATH.VOTE2_LOG_VOTE, {
        ...setPostBody({ }),
      }, null, true
    );
    if (success) dispatch(setVoteLogs(data));
  } catch (error) {
    throw error;
  }
};

export default {};
